import { Entity } from 'components/MyTaskArea/taskDetailConstants';
import { getDocumentUploadFieldName } from 'components/MyTaskArea/utils/mapTaskDetail';

import { buildDocumentFileName } from 'utils/FileUtil';

export const buildTaskDetailFileUploadContext = ({ installer, experts, lastMessageFields }) => ({
  installer: installer?.id != null ? { id: installer.id } : null,
  experts,
  lastMessageFields,
});

export const resolveExpertForDocumentUpload = (experts, lastMessageFields) => {
  const list = experts ?? [];

  if (list.length === 1) {
    return {
      firstName: list[0]?.vorname ?? '',
      lastName: list[0]?.nachname ?? '',
    };
  }

  const specialistEntityIds = [
    ...new Set(
      (lastMessageFields ?? [])
        .filter((field) => Number(field.entity) === Entity.SPECIALIST)
        .map((field) => String(field.entityId))
    ),
  ];

  if (specialistEntityIds.length === 1) {
    const expert = list.find((entry) => String(entry.id) === specialistEntityIds[0]);
    if (expert) {
      return {
        firstName: expert.vorname ?? '',
        lastName: expert.nachname ?? '',
      };
    }
  }

  return null;
};

export const getTaskDetailUploadFiles = (values, fileId) => {
  const fieldValue = values[getDocumentUploadFieldName(fileId)];
  if (!Array.isArray(fieldValue)) {
    return [];
  }
  return fieldValue;
};

export const collectTaskDetailFilesToUpload = (fileEntries, values, context) => {
  const installer = context?.installer ?? null;
  const expert = context
    ? resolveExpertForDocumentUpload(context.experts, context.lastMessageFields)
    : null;

  return fileEntries.flatMap((fileEntry) => {
    const uploaded = values[getDocumentUploadFieldName(fileEntry.id)];
    if (!Array.isArray(uploaded)) {
      return [];
    }

    return uploaded.map((file, index) => {
      const name =
        context && installer
          ? buildDocumentFileName({
              documentType: fileEntry.documentType,
              file,
              installer,
              expert,
              index,
              totalFiles: uploaded.length,
            })
          : (file.name ?? 'document');

      return {
        documentType: fileEntry.documentType,
        file: { ...file, name },
      };
    });
  });
};
